import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import fileIcon from "assets/images/fileIcon.png";
import { Typography } from "components";
import { gray } from "configs/colors";
import { formatDate } from "helpers";

import { ReportDistributionRelation } from "./interface";

const handleSize = (size: number | null | undefined | any) => {
  if (!size) {
    return "";
  }
  return `${Math.floor(size / 1024)} KB`;
};

export const fieldManagementColumn: GridColDef<ReportDistributionRelation>[] = [
  {
    field: "name",
    headerName: "File Name",
    width: 600,
    renderCell: (params) => {
      return (
        <Box display="flex" alignItems="center">
          <Box
            component="img"
            alt={params.row?.originalFileName}
            src={fileIcon}
            sx={{ flex: "0 0 auto" }}
          />
          <Box marginLeft="12px">
            <Typography type="TextSM" fontWeight={500}>
              {params.row?.originalFileName}
            </Typography>
            <Typography type="TextSM" color={gray[600]}>
              {handleSize(params.row?.fileSize)}
            </Typography>
          </Box>
        </Box>
      );
    },
  },
  {
    field: "client",
    headerName: "Client",
    width: 200,
    renderCell: (params) => {
      return params?.row?.customer?.name;
    },
    flex: 1,
  },
  {
    field: "fileSize",
    headerName: "File Size",
    width: 77,
    renderCell: (params) => {
      return (
        <Typography type="TextSM" color={gray[600]}>
          {handleSize(params.row?.fileSize)}
        </Typography>
      );
    },
  },
  {
    field: "fileType",
    headerName: "File Type",
    width: 200,
    renderCell: (params) => {
      return params?.row?.report?.reportType?.name;
    },
  },
  {
    field: "createdAt",
    headerName: "Purchased Date",
    width: 150,
    renderCell: (params) => {
      return formatDate(params?.row?.createdAt);
    },
  },
  {
    field: "expiredAt",
    headerName: "Valid Date",
    width: 108,
    renderCell: (params) => {
      return formatDate(params?.row?.expiredAt);
    },
  },
];
